import React, { useEffect, useState } from "react";
import { API_BASE } from "../config";
import { authHeaders } from "../utils/authHeaders";

function AgentStock() {
  const [agents, setAgents] = useState([]);
  const [products, setProducts] = useState([]);
  const [stockReport, setStockReport] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);

  const [form, setForm] = useState({
    product_id: "",
    quantity: "",
  });

  // Load Agents
  const loadAgents = async () => {
    const res = await fetch(`${API_BASE}/agents`, {
      headers: authHeaders(),
    });
    const data = await res.json();
    setAgents(Array.isArray(data) ? data : []);
  };

  // Load Products
  const loadProducts = async () => {
    const res = await fetch(`${API_BASE}/products/list`, {
      headers: authHeaders(),
    });
    const data = await res.json();
    setProducts(Array.isArray(data) ? data : []);
  };

  // Load Stock Report
  const loadStockReport = async () => {
    const res = await fetch(`${API_BASE}/reports/stock`, {
      headers: authHeaders(),
    });
    const data = await res.json();
    setStockReport(Array.isArray(data) ? data : []);
  };

  useEffect(() => {
    loadAgents();
    loadProducts();
    loadStockReport();
  }, []);

  // Allocate Stock API
  const allocateStock = async () => {
    if (!selectedAgent || !form.product_id || !form.quantity) {
      alert("Please fill all fields");
      return;
    }

    const res = await fetch(`${API_BASE}/stock/allocate`, {
      method: "POST",
      headers: authHeaders({
          "Content-Type": "application/json",
        }),
      body: JSON.stringify({
        agent_id: selectedAgent.id,
        product_id: form.product_id,
        quantity: Number(form.quantity),
      }),
    });

    if (res.status === 200) {
      alert("Stock allocated!");
      setShowModal(false);
      setForm({ product_id: "", quantity: "" });
      loadStockReport();
    } else {
      alert("Error allocating stock");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Agent Stock Allocation</h2>

      <h3>Agents List</h3>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#ddd" }}>
            <th style={{ padding: "10px" }}>Agent Name</th>
            <th>Phone</th>
            <th>Village</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {agents.map((a) => (
            <tr key={a.id} style={{ borderBottom: "1px solid #ccc" }}>
              <td style={{ padding: "10px" }}>{a.name}</td>
              <td>{a.phone}</td>
              <td>{a.village}</td>

              <td>
                <button
                  style={{
                    padding: "6px 12px",
                    background: "#0066ff",
                    border: "none",
                    color: "white",
                    borderRadius: "4px",
                  }}
                  onClick={() => {
                    setSelectedAgent(a);
                    setShowModal(true);
                  }}
                >
                  Allocate Stock
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <hr style={{ margin: "30px 0" }} />

      <h3>Stock Report</h3>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#ddd" }}>
            <th>Agent</th>
            <th>Product</th>
            <th>Allocated Qty</th>
            <th>Available Qty</th>
          </tr>
        </thead>

        <tbody>
          {stockReport.map((s, i) => (
            <tr key={i} style={{ borderBottom: "1px solid #ccc" }}>
              <td style={{ padding: "10px" }}>{s.agent}</td>
              <td>{s.product}</td>
              <td>{s.allocated_qty}</td>
              <td>{s.available_qty}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ALLOCATION MODAL */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "400px",
              background: "white",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <h3>Allocate Stock to {selectedAgent?.name}</h3>

            <select
              style={inputStyle}
              value={form.product_id}
              onChange={(e) =>
                setForm({ ...form, product_id: e.target.value })
              }
            >
              <option value="">Select Product</option>
              {products.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name} (₹{p.price})
                </option>
              ))}
            </select>

            <input
              style={inputStyle}
              type="number"
              placeholder="Quantity"
              value={form.quantity}
              onChange={(e) =>
                setForm({ ...form, quantity: e.target.value })
              }
            />

            <button
              style={saveBtn}
              onClick={allocateStock}
            >
              Save
            </button>

            <button
              style={cancelBtn}
              onClick={() => setShowModal(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// Styles
const inputStyle = {
  width: "100%",
  padding: "10px",
  marginBottom: "10px",
  border: "1px solid #ccc",
};

const saveBtn = {
  background: "#0066ff",
  color: "white",
  padding: "10px",
  width: "100%",
  border: "none",
  borderRadius: "6px",
};

const cancelBtn = {
  background: "grey",
  color: "white",
  padding: "10px",
  width: "100%",
  border: "none",
  borderRadius: "6px",
  marginTop: "10px",
};

export default AgentStock;
